import {Component} from '@angular/core';
import {ViewController, NavParams} from 'ionic-angular';
import {Company} from '../../../../../services/company.service';

@Component({
    template: `
        <ion-list>
            <ion-list-header color="dark">Companies</ion-list-header>
            <button ion-button full color="light" *ngFor="let x of companyList" (click)="selectItem(x)">{{x.name}}</button>
        </ion-list>
    `,
})
export class SubcontractorPopover {

    // Declare our preset title list
    private companyList : Company[];

    constructor( 
        public viewCtrl : ViewController,
    ) {
        // Assign our title list to our preset list
        let navParams : NavParams = this.viewCtrl.getNavParams();
        this.companyList = navParams.get("companyList");
    }
    
    selectItem(item : Company) {
        this.viewCtrl.dismiss({
            selected: item
        });
    }
}
    


// WEBPACK FOOTER //
// ./src/pages/report/tab-main/subcontractor/subcontractor-popover/subcontractor-popover.component.ts